import { ActivityType } from 'models/Activity';
import LearnerQuestionnaire from './components/questionnaire/LearnerQuestionnaire';
import React, { useContext } from 'react';
import LearnerTask from './components/task/LearnerTask';
import LearnerLiveTraining from './components/live-training/LearnerLiveTraining';
import { LearnerCourseContext } from 'contextProviders/LearnerCourseContext';
import { Slide } from 'pages/schedule/courses/live-training/PresentationSlidesSection';

export default function LearnerActivityView(): JSX.Element {
    const learnerCourse = useContext(LearnerCourseContext).learnerCourse!;
    const { step } = useContext(LearnerCourseContext);

    const activity = learnerCourse.modules
        .flatMap((module) => module.activities)
        .find((activity) => activity.activityStatusId === step.id);

    if (!activity) {
        return <>No activity found</>;
    }

    switch (activity.type) {
        case ActivityType.LIVE_TRAINING:
            const slides = learnerCourse.modules
                .find((m) => m.activities.find((a) => a.activityStatusId === activity.activityStatusId))!
                .activities.filter((a) => a.type === ActivityType.PRESENTATION_SLIDE)
                .map((a) => {
                    const slide: Slide = {
                        title: a.title,
                        content: a.content,
                        image: a.imageDocuments.length ? a.imageDocuments[0] : undefined,
                        order: a.order,
                    };

                    return slide;
                });

            return <LearnerLiveTraining liveTraining={activity} slides={slides} />;
        case ActivityType.QUESTIONNAIRE:
            return <LearnerQuestionnaire questionnaire={activity} />;
        case ActivityType.TASK:
        default:
            return <LearnerTask task={activity} />;
    }
}
